module.exports = __webpack_public_path__ + "img/noname.a139c193.jpg";